import React, {useMemo} from 'react';
import {useTable} from "react-table";
import {defaultRenderCell, DefaultTableHeader, DefaultTableRow} from "./healper";
const SimpleDataTable = React.memo(({
                                        columns,
                                        data,
                                        renderCell = defaultRenderCell,
                                        TableHeader = DefaultTableHeader,
                                        TableRow = DefaultTableRow,
                                    }) => {

    const tableInstance = useTable({
        data,
        columns,
    })

    const {getTableProps, getTableBodyProps,headerGroups, rows, prepareRow} = tableInstance;
// debugger
    return (
        <table
            {...getTableProps()}
        >
            {/*<thead>*/}
            {/*{*/}
            {/*    headerGroups.map((headerGroup)=>(*/}
            {/*        <tr {...headerGroup.getHeaderGroupProps()}>*/}
            {/*            {*/}
            {/*                headerGroup.headers.map((column)=>(*/}
            {/*                    <th {...column.getHeaderProps()}>*/}
            {/*                        {column.render('Header')}*/}
            {/*                    </th>*/}
            {/*                ))*/}
            {/*            }*/}

            {/*        </tr>*/}
            {/*    ))*/}
            {/*}*/}

            {/*</thead>*/}
            <TableHeader
                {...tableInstance}
            />

            <tbody
                {...getTableBodyProps()}
            >

            {
                rows.map((row, i) => {

                    prepareRow(row);

                    return (

                        <tr
                            {...row.getRowProps()}
                            key={i.toString()}
                        >

                            {/*{*/}
                            {/*    row.cells.map(cell =>{*/}
                            {/*        return <td {...cell.getCellProps()}>*/}
                            {/*            {cell.render('Cell')}*/}
                            {/*        </td>*/}

                            {/*    })*/}
                            {/*}*/}

                            <TableRow
                                renderCell={renderCell}
                                row={row}
                            />

                        </tr>

                    )

                })
            }

            </tbody>


        </table>
    )
})

export default SimpleDataTable
